import Component from './Component';
import { checkLoginGetStatus, logoutLocal } from '../lib/OidcHelper';
import { getApiServerUrl } from '../../UM-Base/lib/TripPlannerHelper';
import { setRemoteFaves, getRemoteFaves } from '../../UM-Base/lib/ApiHubHelper';
import { localAddProduct, localStorageGetFaves } from '../lib/FavButtonsHelper';
import { initPreferenceFavourites } from './PreferenceFavourites';

let apiHubUrl = '';
let thisComponent = null;
const errorMessageText = "Something went wrong processing your request.";


export default class PreferenceUser extends Component {

  load() {
    super.load();
    if (window.location.pathname.indexOf('preference-centre') !== -1) {
      apiHubUrl = getApiServerUrl();
      thisComponent = this;
      this.initPreferenceUser();
    }
  }

  async initPreferenceUser() {
    // Check Login Status and get "user" and "token".
    let user, token;  // define variables we will destructure into.
    ({ user, token } = await checkLoginGetStatus()); // destructuring object returned into variables.

    $('.js-prefcentre-logout').on('click', logoutLocal);


    if (!!token) { // token exists

      let remoteFaves = await getRemoteFaves(token);
      // console.log('remoteFaves: ', remoteFaves);

      // cleanup remote data
      let remoteFavesClean = remoteFaves?.map(x => { return x.productId })
      // console.log('remoteFavesClean: ', remoteFavesClean);

      let localFaves = JSON.parse(localStorage.getItem('favourites'));
      // console.log('localFaves: ', localFaves);

      if (!!localFaves && !!remoteFavesClean) { // don't filter if either null
        let differenceFaves = localFaves.filter(x => !remoteFavesClean.includes(x));

        if (differenceFaves.length > 0) {
          console.log('faves differenceFaves: ', differenceFaves);
          setRemoteFaves(token, differenceFaves);
        }
      }



      // now that remoteFaves are up-to-date, copy to localFaves.
      remoteFaves?.forEach(item => localAddProduct(item.productId));
      // console.log('localStorageGetFaves:', localStorageGetFaves());

      initPreferenceFavourites(); // use latest localFaves to generate Faves Panel cards.

      showPanel();

      await this.updateUserDetailsInForm(user, token);
      await this.setUpdateUserDetailsAction(user, token)

    }

    if (!token) { // no token
      console.log('not logged in.');
      // Depends on PreferenceMenu.js having created window.panelProps object.
      // We change to the Favourites panel.
      const favePanel = document.querySelector('[data-title="Favourites"]');
      window.panelProps.changePanel(favePanel, window.panelProps.sliderUlWidth, window.panelProps.slideWidth);
      hidePanel();
    }


    // Get the Location fields from dotDigital proxy
    // this.getLocationFieldsFromProxy(user);

    // Change state field on country change
    this.toggleStateFieldOnCountryChange();

    // Show email message on click of email field

    // TODO: Fix this below

    this.showEmailMessageOnClick();
  }


  async getCustomerInformation(email, token) {

    if (email && token) {
      const url = `${apiHubUrl}/api/optimizely/getCustomerProfile?email=${email}`;

      let fetchRespData = await fetch(url, {
        method: "GET",
        headers: {
          'accept': '*/*',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        //body: JSON.stringify(requestBody),
        mode: "cors", // no-cors, *cors, same-origin
      }).then(res => {

        if (res && res.status != 200) {
          console.error(`getCustomerProfileAttributes() Request not 200. Response:`, res);
          var preferenceContainer = document.getElementsByClassName("pref-subscriptions");
          if (preferenceContainer) {
            preferenceContainer.style.display = "none";
          }
        } else {
          console.log("Retrieve information successfull.");
          return res.json(); // translate response stream to JSON
        }
      }).then(respData => {
        return respData;

      }).catch(error => {
        console.log('GET failed: ', error);

        if (error.status == 401) {
          console.error(`getCustomerProfileAttributes()- Unauthorized response status code: `, error.status);
        }
      });

      var returnResult = null;

      if (fetchRespData && fetchRespData?.data?.attributes) {
        returnResult = fetchRespData?.data.attributes;
      }
      return returnResult;
    }
  }


  async updateUserDetailsInForm(user, token) {
    if (!user) {
      // history.back();
      return;
    }

    const email = user.profile.email;
    const firstName = user.profile.given_name;
    const lastName = user.profile.family_name;
    const odpUserDetails = Promise.resolve(thisComponent.getCustomerInformation(email, token));

    odpUserDetails.then((data) => {

      document.querySelector('#ViewModel_Email').value = email;
      document.querySelector('#ViewModel_FirstName').value = data && data.first_name ? data.first_name : firstName;
      document.querySelector('#ViewModel_LastName').value = data && data.last_name ? data.last_name : lastName;
      document.querySelector('#ViewModel_Postcode').value = data && data.zip;

      let selectStateElement = document.getElementById("search-filters-state");
      let stateOptions = selectStateElement.options;
      const state = data?.state;

      if (data?.country && data?.country === "Australia") {
        for (let i = 0; i < stateOptions.length; i++) {

          if (stateOptions[i]?.value?.trim() === state) {

            selectStateElement.selectedIndex = i;
            selectStateElement.nextSibling.querySelector("span").innerHTML = state;
            break;
          }
        }
      } else {
        document.getElementById('ViewModel_State').value = state;
      }

      let selectCountryElement = document.getElementById("search-filters-country");
      let countryOptions = selectCountryElement.options;
      const country = data?.country;

      for (let i = 0; i < countryOptions.length; i++) {

        if (countryOptions[i]?.value?.toLowerCase()?.trim() === country?.toLowerCase()) {
          selectCountryElement.selectedIndex = i;
          selectCountryElement.nextSibling.querySelector("span").innerHTML = country;

          //hide the state because it is only applicable to Australia.
          const stateSelect = document.querySelector('#search-filters-state').parentElement;
          const stateInput = document.querySelector('#ViewModel_State');
          const stateTextIcon = document.querySelector('#ViewModel_State + .pref-centre-panel__icon-text')
          if (data.country === 'Australia') {
            stateSelect.classList.remove('hide');
            stateInput.classList.add('hide');
            if (stateTextIcon) {
              stateTextIcon.classList.add('hide');
            }
          } else {
            stateSelect.classList.add('hide');
            stateInput.classList.remove('hide');
            if (stateTextIcon) {
              stateTextIcon.classList.remove('hide');
            }
          }

          break;
        }
      }
    })
  }


  async setUpdateUserDetailsAction(user, token) {

    document.getElementById("save-user-details").addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default form submission behavior

      let userFormDetails = thisComponent.extractFieldValues();
      Promise.resolve(thisComponent.createUpdateProfile(userFormDetails, user.profile.email, token));
    });
  }


  async createUpdateProfile(userDetails, email, token) {

    if (email && token) {
      const url = `${apiHubUrl}/api/Optimizely/CreateUpdateProfile`;

      let requestBody = {
        isSavePreferenceDetails: false,
        "attributes": {
          email: `${email}`,
        }
      }
      // add additional attributes
      Object.assign(requestBody.attributes, userDetails);


      await fetch(url, {
        method: "POST",
        headers: {
          'accept': '*/*',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody),
        mode: "cors", // no-cors, *cors, same-origin
      }).then(res => {

        if (res && res.status != 200) {
          thisComponent.showModalContentAndTimeout(errorMessageText + "<br/>Error: Check user details is not valid: " + error.status, 10000);
          console.error("createUpdateProfile() Request not 200. Response:", res);
        } else {

          thisComponent.showModalContentAndTimeout("You have successfully updated your personal details.", 5000, true);
          return res.json(); // translate response stream to JSON
        }
      }).then(respData => {
        return respData;

      }).catch(error => {
        console.log('POST failed: ', error);

        if (error.status == 401) {
          thisComponent.showModalContentAndTimeout(errorMessageText + "<br/>Error: Unauthorized response status code: " + error.status, 10000, false);
          console.error("createUpdateProfile() - Unauthorized response status code: ", error.status);
        }
      });
    }

  }


  extractFieldValues() {
    var formData = {};

    // Extracting values from input fields
    formData.first_name = document.getElementById('ViewModel_FirstName').value;
    formData.last_name = document.getElementById('ViewModel_LastName').value;
    formData.email = document.getElementById('ViewModel_Email').value;
    formData.city = "";
    formData.zip = document.getElementById('ViewModel_Postcode').value;
    let JCFStateInput = document.getElementById('search-filters-state');

    if (JCFStateInput.offsetParent !== null) {
      // Extracting value from the "State" dropdown option
      formData.state = JCFStateInput.value;

    } else {
      formData.state = document.getElementById('ViewModel_State').value;
    }

    // Extracting value from the "Country" dropdown menu
    formData.country = document.getElementById('search-filters-country').value;

    return formData;
  }


  toggleStateFieldOnCountryChange() {
    const countrySelect = document.querySelector('#search-filters-country');
    countrySelect.addEventListener('change', () => {

      const stateSelect = document.querySelector('#search-filters-state').parentElement;
      const stateInput = document.querySelector('#ViewModel_State');
      // Set the value for the country select option
      let selectCountryElement = document.getElementById("search-filters-country");
      selectCountryElement.nextSibling.querySelector("span").innerHTML = countrySelect.value;
      const stateTextIcon = document.querySelector('#ViewModel_State + .pref-centre-panel__icon-text')
      if (countrySelect.value === 'Australia') {
        stateSelect.classList.remove('hide');
        stateInput.classList.add('hide');
        stateTextIcon.classList.add('hide');
      } else {
        stateSelect.classList.add('hide');
        stateInput.classList.remove('hide');
        if (stateTextIcon) {
          stateTextIcon.classList.remove('hide');
        }
      }
    });
  }


  showEmailMessageOnClick() {
    const field = document.querySelector('#ViewModel_Email');
    field.addEventListener('click', () => {
      const message = document.querySelector('.pref-centre-panel__email-message');
      message.classList.remove('hide');
    });
  }


  truncateString(str, num) {
    if (typeof str !== 'string' || str.length <= num) {
      return str
    }
    return str.slice(0, num);
  }


  showModalContentAndTimeout(content, timeout, isSuccess) {
    let modalContainer = document.getElementById('preference-user-modal');
    var modalBody = modalContainer.getElementsByClassName('modal-body')[0];
    modalBody.innerHTML = content;
    if (isSuccess) {
      modalBody.classList.add("alert-success");
    } else if (isSuccess === false) {
      modalBody.classList.add("alert-danger");
    }

    $('#preference-user-modal').modal('show');

    // Ensure timeout is a number and greater than 0
    if (typeof timeout !== 'number' || timeout <= 0) {
      console.error('Invalid timeout value:', timeout);
      return;
    }

    setTimeout(function () {
      $('#preference-user-modal').modal('hide');
    }, timeout);
  }

}

function showPanel() {
  $('[disabled]').removeAttr('disabled');
  $('.pc-shadow').removeClass('pc-shadow');
}

function hidePanel() {
  $('.pc-user').addClass('pc-shadow');
  $(`
    .pc-profile input,
    .pc-profile select,
    .pc-profile button
  `).prop("disabled", true);
}
